import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

type Props = {
  open: boolean
  title?: string
  message: string
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmDialog = ({
  open,
  title = 'Confirmare',
  message,
  onConfirm,
  onCancel,
}: Props) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth='xs' fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ padding: '12px 24px', gap: '8px' }}>
        <Button
          onClick={onCancel}
          variant='outlined'
          sx={{
            color: '#666',
            borderColor: '#ccc',
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': { borderColor: '#999', backgroundColor: '#f5f5f5' },
          }}
        >
          Anulează
        </Button>
        <Button
          onClick={onConfirm}
          variant='contained'
          sx={{
            backgroundColor: 'var(--color-primary)',
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': { backgroundColor: 'var(--color-primary-hover)' },
          }}
        >
          Confirmă
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
